var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
export class ModelLoader {
    constructor() {
        this.cache = new Map();
        this.loader = new GLTFLoader();
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath('./three/draco/gltf/');
        this.loader.setDRACOLoader(dracoLoader);
    }
    load(path_1) {
        return __awaiter(this, arguments, void 0, function* (path, onProgress = () => { }) {
            if (this.cache.has(path)) {
                return Promise.resolve(this.cache.get(path));
            }
            return new Promise((resolve, reject) => {
                this.loader.load(path, (gltf) => {
                    this.cache.set(path, gltf.scene);
                    resolve(gltf.scene);
                }, onProgress, reject);
            });
        });
    }
}
//# sourceMappingURL=ModelLoader.js.map